import { Component, OnInit } from '@angular/core';

// import { _ } from 'underscore';
import * as _ from 'underscore';
import { ValidationService } from '../validation.service';
import { SnackbarService } from '../snackbar.service';
import { MatDialogRef } from '@angular/material';
import { HttpService } from '../http.service';
import {Messages} from '../constants/messages'

declare var google: any;


export interface OrganisationLocation {
  latitude: number;
  longitude: number;
  area: string;
  city: string;
  locality: string;
}

export interface Organisation {
  name: string;
  mobile?: string;
  email_id?: string;
  location: OrganisationLocation;
}

@Component({
  selector: 'app-organisation-name',
  templateUrl: './organisation-name.component.html',
  styleUrls: ['./organisation-name.component.scss']
})
export class OrganisationNameComponent implements OnInit {


  organisation: Organisation = {
    name: '',
    location: {
      latitude: 0,
      longitude: 0,
      area: '',
      city: '',
      locality: ''
    }
  };

  messages = new Messages();

  constructor(private valid: ValidationService, private snackBar: SnackbarService, private dialog: MatDialogRef<OrganisationNameComponent>, private http: HttpService) { }

  ngOnInit() {
    this.initAutoSuggestions();
  }
  initAutoSuggestions() {

    const input = document.getElementById('placesSearch');
    const options = {

    };

    let autocomplete = new google.maps.places.Autocomplete(input, options);
    let context = this;
    autocomplete.addListener('place_changed', function() {
      let place = autocomplete.getPlace();
      context.organisation.location.latitude = place.geometry.location.lat();
      context.organisation.location.longitude = place.geometry.location.lng();
      context.organisation.location.locality = (place.address_components[place.address_components.length - 1].types.includes('postal_code')) ? place.address_components[place.address_components.length - 1].long_name : '';
      context.organisation.location.area = place.formatted_address;
      const city = _.filter(place.address_components, (city) => {
        if (_.contains(city.types, 'locality')){
          return city.long_name;
        } else if (_.contains(city.types, 'administrative_area_level_1')){
          return city.long_name;
        }
      });
      context.organisation.location.city = city[0].long_name;

      if (!place.geometry) {
        return;
      }
    });
  }
  createOrganisation() {
    if (this.valid.notEmpty(this.organisation.name) && this.valid.notEmpty(this.organisation.location.latitude)) {

      this.http.post('organization/create', this.organisation).subscribe(
        (data: any) => {
          if (data.statusCode == 200) {
            this.snackBar.openSnackBar(this.messages.ORGANISATION.SUCCESS.ORGANISATION_ADD, '');
            this.dialog.close({ organisation: data });
          } else {
            console.log(' >> ',data)
          }
        },
        (err: any) => {
          this.snackBar.openSnackBar(err.error.message, '', 'err');
          if (err.error.statusCode == 401) {
            this.valid.logout();
          }
        }
      );
    } else {
      this.snackBar.openSnackBar(this.messages.ORGANISATION.VALIDATION.FILL_ALL, '','warn');
    }
  }

  closeDialog() {
    this.dialog.close({close: ''});
  }
}
